module.exports = __webpack_public_path__ + "static/media/accessory__tiltSensor.89ebd095.jpg";